import css from "./Companies.module.css";
import PageHead from "../../../Components/PageHead/PageHead";
import { useState, useEffect } from "react";
import Url from "../../../Services/Url";
import { Get } from "../../../Services/Server";
import DataTable from "../../../Components/DataTable/DataTable";
import { useNavigate } from "react-router-dom";
import Utils from "../../../Services/Utills";
import { Eye } from "lucide-react";
import CompanyTaskTooltip from "../../../Components/CompanyTaskToolTip/CompanyTaskToolTip";

const CompanyList = ({ navoption }) => {
	const [list, setList] = useState([]);
	const [page, setPage] = useState({ pageable: null, totalPage: null });
	const [data, setData] = useState([]);
	const [isSearching, setIsSearching] = useState(false);
	const [searchKeyword, setSearchKeyword] = useState("");
	const [tooltip, setTooltip] = useState({
		visible: false,
		position: { x: 0, y: 0 },
		company: null,
	});

	const navigate = useNavigate();
	const handleTooltipClick = (company, e) => {
		e.stopPropagation();
		const rect = e.currentTarget.getBoundingClientRect();
		setTooltip({
			visible: true,
			position: { x: rect.left + rect.width / 2, y: rect.bottom + 10 },
			company,
		});
	};

	const closeTooltip = () =>
		setTooltip({ visible: false, position: { x: 0, y: 0 }, company: null });

	useEffect(() => {
		if (tooltip.visible) {
			document.addEventListener("mousedown", closeTooltip);
		}
		return () => document.removeEventListener("mousedown", closeTooltip);
	}, [tooltip.visible]);

	const reader = (e) => {
		return [
			e.name,
			e.email || "-",
			e.companyTrackingCode || "-",
			e.phone || "-",
			<div
				className="chat-icon-cell"
				onClick={(ev) => handleTooltipClick(e, ev)}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					cursor: "pointer",
					padding: "6px",
					borderRadius: "50%",
					width: "32px",
					height: "32px",
					backgroundColor: "#f9f9f9",
					border: "2px solid #14b8ff",
				}}
				title="View tasks"
			>
				<Eye size={16} />
			</div>,
		];
	};

	// load page normally
	const loadPage = (pg) => {
		Get(Url.enterpriseCompany.get.page(pg)).then((resp) => {
			setList(resp.content);
			setPage({ pageable: resp.pageable, totalPage: resp.totalPages });
			setData(resp.content);
			setIsSearching(false);
		});
	};

	const handlePagination = (pg) => {
		if (isSearching && searchKeyword.trim()) {
			Get(Url.enterpriseCompany.search(searchKeyword, pg)).then((resp) => {
				setData(resp.content);
				setPage({ pageable: resp.pageable, totalPage: resp.totalPages });
			});
		} else {
			loadPage(pg);
		}
	};

	useEffect(() => {
		loadPage(0);
	}, []);

	const handleAddComp = () => {
		navigate("Create");
	};

	const handleClick = (e) => {
		navigate(`${e.id}`);
	};

	const onSearch = (keyword) => {
		setSearchKeyword(keyword);
		if (keyword.trim()) {
			Get(Url.enterpriseCompany.search(keyword, 0)).then((resp) => {
				setData(resp.content);
				setPage({ pageable: resp.pageable, totalPage: resp.totalPages });
				setIsSearching(true);
			});
		} else {
			loadPage(0);
		}
	};

	const heading = ["Company", "Email","Code", "Phone", "Tasks"];

	return (
		<div className={css.Companies}>
			<PageHead
				onSearch={onSearch}
				navoption={navoption}
				addBtn={{ text: "Company", onClick: handleAddComp }}
				title="Companies"
			/>
			<div className={css.Record}>
				<DataTable
					handlePagination={handlePagination}
					pageable={page.pageable}
					totalPages={page.totalPage}
					onClick={handleClick}
					flex={[25, 25,25,20, 5]}
					reader={reader}
					transform={Utils.toPascalCase}
				>
					{{ data, heading }}
				</DataTable>
			</div>
			{tooltip.visible && (
				<CompanyTaskTooltip
					company={tooltip.company}
					isVisible={tooltip.visible}
					position={tooltip.position}
				/>
			)}
		</div>
	);
};

export default CompanyList;
